import { useContext } from "react";
import {
  FeaturesShowcaseModalContext,
  FeaturesShowcaseModalContextType,
} from "./FeaturesShowcaseModalContext";

export const useFeaturesShowcaseModal =
  (): FeaturesShowcaseModalContextType => {
    const context = useContext(FeaturesShowcaseModalContext);
    if (!context) {
      throw new Error(
        "useCreateWorkspaceLoader must be used within a CreateWorkspaceLoaderProvider"
      );
    }
    return context;
  };
